var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        title: _vm.modalTitle,
        "mask-closable": false,
        loading: _vm.modal.submitLoading,
        width: "700",
      },
      on: { "on-cancel": _vm.handleModalCancel },
      model: {
        value: _vm.modal.visible,
        callback: function ($$v) {
          _vm.$set(_vm.modal, "visible", $$v)
        },
        expression: "modal.visible",
      },
    },
    [
      _c(
        "Form",
        {
          ref: "companyForm",
          attrs: {
            model: _vm.modal.form,
            rules: _vm.modal.rules,
            "label-position": "top",
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c(
                "div",
                { staticClass: "section-title" },
                [
                  _c("Icon", {
                    attrs: {
                      type: "ios-business",
                      size: "16",
                      color: "#2d8cf0",
                    },
                  }),
                  _c("span", [_vm._v("基本信息")]),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "公司名称", prop: "name" } },
                        [
                          _c(
                            "Input",
                            {
                              attrs: {
                                placeholder: "请输入公司名称",
                                maxlength: 100,
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.modal.form.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.modal.form, "name", $$v)
                                },
                                expression: "modal.form.name",
                              },
                            },
                            [
                              _c("Icon", {
                                attrs: { slot: "prefix", type: "ios-business" },
                                slot: "prefix",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c(
                "div",
                { staticClass: "section-title" },
                [
                  _c("Icon", {
                    attrs: { type: "ios-paper", size: "16", color: "#ed4014" },
                  }),
                  _c("span", [_vm._v("其他信息")]),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "RadioGroup",
                            {
                              attrs: { type: "button" },
                              model: {
                                value: _vm.modal.form.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.modal.form, "status", $$v)
                                },
                                expression: "modal.form.status",
                              },
                            },
                            [
                              _c(
                                "Radio",
                                { attrs: { label: "1" } },
                                [
                                  _c("Icon", {
                                    attrs: {
                                      type: "ios-checkmark-circle",
                                      color: "#19be6b",
                                    },
                                  }),
                                  _vm._v(
                                    "\n                                启用\n                            "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Radio",
                                { attrs: { label: "0" } },
                                [
                                  _c("Icon", {
                                    attrs: {
                                      type: "ios-close-circle",
                                      color: "#ed4014",
                                    },
                                  }),
                                  _vm._v(
                                    "\n                                禁用\n                            "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("Button", { on: { click: _vm.handleModalCancel } }, [
            _vm._v("取消"),
          ]),
          _c(
            "Button",
            {
              attrs: { type: "primary", loading: _vm.modal.submitLoading },
              on: { click: _vm.handleModalOk },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.modal.isEdit ? "保存" : "创建") +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }